import { Actions, ActionsTypes } from './diagnosis-treatments.actions';
import {
  State as DiagnosisState,
  initialState as diagnosisInitialState,
} from './diagnosis-treatments.state';
import { SearchModel, DiagnosisTreanment } from '@nrwl/rx-models';
import { environment } from '@nrwl/environment';

export function Reducer(state = diagnosisInitialState, action: Actions): DiagnosisState {
  switch (action.type) {
    // #region load diagnosis

    case ActionsTypes.LoadUsedDiagnosis:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedDiagnosisSuccess:
      return {
        ...state,
        diagnosis: [
          {
            name: 'None',
            id: 0,
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload,
        ],
      };

    // #endregion

    // #region load treatments

    case ActionsTypes.LoadUsedTreatments:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedTreatmentsSuccess:
      return {
        ...state,
        treatments: [
          {
            name: 'None',
            id: 0,
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload,
        ],
      };

    // #endregion

    // #region load surgeon

    case ActionsTypes.LoadUsedSurgeons:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedSurgeonsSuccess:
      return {
        ...state,
        surgeons: [
          {
            name: 'None',
            id: 'no_surgeons',
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload.results,
        ],
      };

    // #endregion

    // #region load visit types

    case ActionsTypes.LoadUsedVisitTypes:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedVisitTypesSuccess:
      return {
        ...state,
        visitTypes: [
          {
            name: 'None',
            id: 'no_visit_types',
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload.results,
        ],
      };

    // #endregion

    // #region load procedure types

    case ActionsTypes.LoadUsedProcedureTypes:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedProcedureTypesSuccess:
      return {
        ...state,
        procedureTypes: [
          {
            name: 'None',
            id: 'no_procedure_types',
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload.results,
        ],
      };

    // #region load surgeon

    case ActionsTypes.LoadUsedBodyParts:
      return {
        ...state,
      };

    case ActionsTypes.LoadUsedBodyPartsSuccess: {
      let payload = Object.values(action.payload);
      payload = payload
        .filter((i) => !!i)
        .map((i) => ({
          // Corrected: return an object
          ...i,
          selected: false,
        }))
        .sort((a, b) => {
          const nameA = a['name'].toLowerCase();
          const nameB = b['name'].toLowerCase();
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
        });

      return {
        ...state,
        bodyParts: [
          {
            name: 'Untitled',
            id: environment.staging ? 439 : 366,
            selected: false,
          },

          { name: 'Quick Snap', id: 832, selected: false },
          { name: 'Client Upload', id: 836, selected: false },
          { name: 'Compare', id: 4452, selected: false },
          ...payload,
        ],
      };
    }

    // #endregion

    // #region load form titles

    case ActionsTypes.LoadFormTitles:
      return {
        ...state,
      };

    case ActionsTypes.LoadFormTitlesSuccess: {
      const formTitles = Object.values(action.payload.results)
        .filter((value) => !!value)
        // .filter((value, idx, self) => self.findIndex(items => items['title'] === value['title']) === idx)
        .map(({ title }: any) => ({ name: title, id: title }))
        .sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
        });
      return {
        ...state,
        formTitle: formTitles,
      };
    }
    // #endregion

    case ActionsTypes.LoadFormProvidersSuccess: {
      const formProviders = Object.values(action.payload.results)
        .filter((value) => !!value)
        // .filter((value, idx, self) => self.findIndex(items => items['title'] === value['title']) === idx)
        .map(({ id, first_name, last_name }: any) => ({
          name: first_name + ' ' + last_name,
          id,
        }))
        .sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
        });
      return {
        ...state,
        formProviders: [{ name: 'Unassigned', id: 'unassigned' }, ...formProviders],
      };
    }

    // #region search states

    case ActionsTypes.Search:
      return {
        ...state,
        search: action.payload,
      };

    // #endregion

    // #region reset search states

    case ActionsTypes.ResetSearch:
      state.search = new SearchModel('');
      return {
        ...state,
      };

    // #endregion

    // #region selected sort

    case ActionsTypes.SelectedSort:
      return {
        ...state,
        ordering: action.payload,
      };

    // #endregion

    // #region selected diagnosis

    case ActionsTypes.SelectedDiagnosis:
      const updatedDiagnosis = state.diagnosis.map((item) => {
        const nItem = new DiagnosisTreanment(item);

        if (nItem.id === action.payload.id) {
          nItem.selected = action.payload.checked;
        }

        return nItem;
      });

      return {
        ...state,
        diagnosis: [...updatedDiagnosis],
      };

    // #endregion

    // #region selected treatments

    case ActionsTypes.SelectedTreatments:
      const updatedTreatments = state.treatments.map((item) => {
        const nItem = new DiagnosisTreanment(item);

        if (nItem.id === action.payload.id) {
          nItem.selected = action.payload.checked;
        }

        return nItem;
      });

      return {
        ...state,
        treatments: [...updatedTreatments],
      };

    // #endregion

    // #region selected treatments

    case ActionsTypes.SelectedSurgeons:
      const updatedSurgeons = state.surgeons.map((item) => {
        const nItem = new DiagnosisTreanment(item);

        if (nItem.id === action.payload.id) {
          nItem.selected = action.payload.checked;
        }

        return nItem;
      });

      return {
        ...state,
        surgeons: [...updatedSurgeons],
      };

    // #endregion

    // #region disable selected
    case ActionsTypes.DisableDiagnosis:
      return {
        ...state,
        diagnosis: state.diagnosis.map((item) => ({
          ...item,
          selected: false,
        })),
      };

    case ActionsTypes.DisableTreatments:
      return {
        ...state,
        treatments: state.treatments.map((item) => ({
          ...item,
          selected: false,
        })),
      };

    case ActionsTypes.DisableSurgeons:
      return {
        ...state,
        surgeons: state.surgeons.map((item) => ({
          ...item,
          selected: false,
        })),
      };
    // #endregion

    // #region Error

    case ActionsTypes.Error:
      return {
        ...state,
        error: action.payload,
      };

    // #endregion

    case ActionsTypes.LoadAreaImplantsSuccess:
      return {
        ...state,
        areaImplants: [
          {
            name: 'None',
            id: 'no_area',
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload.results,
        ],
      };

    case ActionsTypes.LoadImplantVolumesSuccess:
      return {
        ...state,
        implantVolumes: [
          {
            name: 'None',
            id: 'no_implant_volume',
            selected: false,
          } as DiagnosisTreanment,
          ...action.payload.results,
        ],
      };

    case ActionsTypes.LoadImplantPlanesSuccess:
      const implantPlanes = [
        {
          name: 'None',
          id: 'no_implant_planes',
          selected: false,
        } as DiagnosisTreanment,
        ...action.payload.results,
      ];
      return {
        ...state,
        implantPlanes,
      };

    case ActionsTypes.LoadBMIDataSuccess:
      const bmiData = [
        {
          name: 'None',
          id: 'no_bmi',
          selected: false,
        } as DiagnosisTreanment,
        ...action.payload.results,
      ];
      return {
        ...state,
        bmiData,
      };

    case ActionsTypes.LoadSkinToneDataSuccess:
      const skinToneData = [
        {
          name: 'None',
          id: 'no_skin_tone',
          selected: false,
        } as DiagnosisTreanment,
        ...action.payload.results,
      ];
      return {
        ...state,
        skinToneData,
      };

    default:
      return state;
  }
}
